import { render, staticRenderFns } from "./NxAbout.vue?vue&type=template&id=080af818&scoped=true"
import script from "./NxAbout.vue?vue&type=script&lang=js"
export * from "./NxAbout.vue?vue&type=script&lang=js"
import style0 from "./NxAbout.vue?vue&type=style&index=0&id=080af818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080af818",
  null
  
)

export default component.exports